import React from 'react';

const IaCConsulting: React.FC = () => {
  return (
    <div className="page iac-consulting">
      <div className="container">
        <div className="hero-section">
          <h1>Infrastructure as Code Consulting</h1>
          <p className="hero-description">
            Implementation and optimization of Infrastructure as Code practices using 
            tools like Terraform, CloudFormation, and Ansible.
          </p>
        </div>

        <section className="coming-soon-section">
          <div className="coming-soon-card">
            <div className="coming-soon-icon">
              <i className="fa-solid fa-code"></i>
            </div>
            <h2>Coming Soon</h2>
            <p>
              Detailed IaC consulting services are currently under development. This page will include 
              comprehensive information about infrastructure automation, code templates, 
              best practices, and implementation strategies.
            </p>
            <a href="/contact" className="contact-btn">Contact for Early Access</a>
          </div>
        </section>
      </div>
    </div>
  );
};

export default IaCConsulting;